import React, {useEffect, useMemo, useState} from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../../../../../_metronic/helpers'
import {getUnitBranchAllSimple} from '../../../../../../services/unitBranchService'
import {useToast} from '../../../../../components/Toats'
import {Loading} from '../../../../../components/Loadings/loading'
import styles from '../../modalUnitConsumer.module.css'

type Props = {
  plants: any[]
  formik: any
  loading?: boolean
}

const PLANT_ICON = toAbsoluteUrl('/media/imgs/plant2.png')

const ListPlantsLinked: React.FC<Props> = ({plants, formik, loading}) => {
  const {toggleToast} = useToast()
  const [search, setSearch] = useState('')
  const [unitBranchs, setUnitBranchs] = useState<any[]>([])

  useEffect(() => {
    getUnitBranchAllSimple()
      .then(setUnitBranchs)
      .catch(() => toggleToast('Erro ao buscar a lista de unidades. ', 'error'))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const selectedPlant = plants.find((plant) => plant.id === formik.values.idPlant)

  const filteredPlants = useMemo(() => {
    const term = search.trim().toLowerCase()
    const list = term
      ? plants.filter((plant) => (plant.name || '').toLowerCase().includes(term))
      : plants
    // usina selecionada sempre no topo
    return [...list].sort((a, b) => {
      if (a.id === formik.values.idPlant) return -1
      if (b.id === formik.values.idPlant) return 1
      return 0
    })
  }, [plants, search, formik.values.idPlant])

  const togglePlant = (plantId: string) => {
    formik.setFieldValue('idPlant', formik.values.idPlant === plantId ? null : plantId)
  }

  return (
    <>
      {selectedPlant && (
        <div className={styles.selectedPlant}>
          <KTSVG
            path='/media/icons/duotune/arrows/arr085.svg'
            className='svg-icon-2 svg-icon-primary'
          />
          <span className={styles.selectedPlantName} title={selectedPlant.name}>
            {selectedPlant.name}
          </span>
          <button
            type='button'
            className='btn btn-sm btn-link btn-color-gray-600 btn-active-color-danger ms-auto p-0'
            onClick={() => formik.setFieldValue('idPlant', null)}
          >
            Remover
          </button>
        </div>
      )}

      <div className={styles.plantFilters}>
        <input
          type='search'
          className='form-control form-control-sm form-control-solid'
          placeholder='Buscar usina pelo nome'
          value={search}
          onChange={(event) => setSearch(event.target.value)}
          style={{height: '2.75rem'}}
        />
        <select
          className='form-select form-select-sm form-select-solid'
          value={formik.values.idUnitBranch || ''}
          onChange={(event) => formik.setFieldValue('idUnitBranch', event.target.value || null)}
          style={{height: '2.75rem'}}
        >
          <option value=''>Todas as filiais</option>
          {unitBranchs.map((unitBranch: any) => (
            <option key={unitBranch.id} value={unitBranch.id}>
              {unitBranch.companyName}
            </option>
          ))}
        </select>
      </div>

      <div className={styles.plantList} role='radiogroup' aria-label='Usinas'>
        {loading ? (
          <div className={styles.emptyBox}>
            <Loading myClass='spinner-border' style={{width: '2rem', height: '2rem'}} />
          </div>
        ) : filteredPlants.length > 0 ? (
          filteredPlants.map((plant: any) => {
            const selected = formik.values.idPlant === plant.id
            return (
              <button
                key={plant.id}
                type='button'
                role='radio'
                aria-checked={selected}
                className={`${styles.plantItem} ${selected ? styles.plantItemSelected : ''}`}
                onClick={() => togglePlant(plant.id)}
              >
                <img src={PLANT_ICON} alt='' className={styles.plantItemIcon} />
                <span className={styles.plantItemText}>
                  <span className={styles.plantItemName}>{plant.name}</span>
                  <span className={styles.plantItemAddress}>
                    {plant.address ? plant.address : 'Endereço não localizado'}
                  </span>
                </span>
                <span className={`${styles.radio} ${selected ? styles.radioChecked : ''}`} />
              </button>
            )
          })
        ) : (
          <div className={styles.emptyBox}>
            <KTSVG
              path='/media/icons/duotune/general/gen004.svg'
              className='svg-icon-2x svg-icon-muted'
            />
            {search ? 'Nenhuma usina encontrada para essa busca.' : 'Não há usinas disponíveis.'}
          </div>
        )}
      </div>
    </>
  )
}

export {ListPlantsLinked}
